// @flow
import React from 'react';

import { TCO_CLUSTER_MISSION_CRITICAL_BACKEND_FIELD_NAME } from '../../../constants';
import { CheckBoxField } from '../../../formik-utils/FormFields';
import { TCO_CLUSTER_LEVEL_INPUTS_CONFIG_MAP } from '../../../configuration/tco-cluster-inputs';

export const MissionCriticalInputContainer = () => {
  const { backendFieldName, displayName, pathToFollowInValues, tooltip } =
    TCO_CLUSTER_LEVEL_INPUTS_CONFIG_MAP.get(TCO_CLUSTER_MISSION_CRITICAL_BACKEND_FIELD_NAME);

  return (
    <CheckBoxField
      displayCheckBoxBelowLabel={true}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      pathToFollowInValues={pathToFollowInValues}
      tooltip={tooltip}
    />
  );
};
